import * as React from 'react';
import Result from "./Result";
import { VolumetricParameter, FlowParameter, DiffusingCapacityParameter, PressureParameter } from './PFTAPITypes';
export interface AverageResultProps {
    result: VolumetricParameter | FlowParameter | DiffusingCapacityParameter | PressureParameter;
    isLoading?: boolean;
}
export default class AverageResult extends React.PureComponent<AverageResultProps> {
    render() {
        return (
            <td data-automationid={`average-result-${this.props.result.ParameterType}`}>
                <Result isLoading={this.props.isLoading} parameter={this.props.result} />
            </td>
        );
    }
}